<script setup>
import { watch } from "vue";
import { useRouter } from "vue-router/composables";
import Auth0 from "@/components/General/Auth/auth0";
import BaseAuth from "@/components/General/Auth/baseAuth";

const router = useRouter();

// Start the callback logic after the Auth0 client is created
watch(
  () => Auth0.isLoading(),
  async () => {
    if (Auth0.isLoading() || !BaseAuth.useAuth0()) return;

    // Redirect the user to the login page if they aren't authorized
    // This shouldn't happen under normal circumstances
    if (!Auth0.isAuthenticated()) {
      await router.push({ name: "login" });

      return;
    }

    // Set the user data
    const user = await Auth0.getUser();
    await Auth0.updateUserData(user);

    await router.push({ name: "projectWorkflows" });
  },
  { immediate: true }
);
</script>

<template>
  <span></span>
</template>
